<template>
  <div class="date-picker">
    <date-picker
      :type="computedType"
      :format="computedFormat"
      :confirm="true"
      :clearable="false"
      :editable="false"
      :disabled="disabled"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :disabled-date="disableBeforeToday"
      @change="handleChange"
    />
  </div>
</template>

<script>
import addDays from 'date-fns/addDays';
import DatePicker from 'vue2-datepicker';
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: null,
    },
    disableDates: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTimeOnly: {
      type: Boolean,
      default: false,
    },
    displayFormat: {
      type: String,
      default: '', // "D MMM YYYY HH:mm:ss" | "YYYY-MM-DD HH:mm:ss" | "HH"
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedFormat() {
      if (this.displayFormat) {
        return this.displayFormat;
      }
      return this.isTimeOnly ? 'HH' : 'YYYY-MM-DD HH:mm:ss';
    },
    computedType() {
      if (this.type) {
        return this.type;
      }
      return this.isTimeOnly ? 'time' : 'datetime';
    },
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    disableBeforeToday(date) {
      const yesterdayDate = addDays(new Date(), this.disableDates);
      return date < yesterdayDate;
    },
  },
};
</script>

<style>
/* _._ */
.date-picker input {
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  color: #1f1f1f;
  font-size: 14px;
  font-weight: 500;
}
</style>
